export default __webpack_public_path__ + "static/media/ID.fccc99b7.webp";